import { AxiosHeaders, AxiosRequestConfig } from 'axios';

import { getWebStoreApiClient } from '@gn-audio/core';

import { getAuthBearerValue } from '../../auth/web-store-api/utilities';
import { HttpHeader } from '../../common';

export const getPricingHeaders = async (shopApiClientId?: string): Promise<AxiosRequestConfig> => {
  const requestHeaders = new AxiosHeaders();

  if (shopApiClientId) {
    requestHeaders.set(HttpHeader.ClientId, shopApiClientId);
  } else {
    console.warn('SFCC Client ID is not set');
  }
  const token = await getWebStoreApiClient().onTokenAcquired;
  requestHeaders.set(HttpHeader.ContentType, 'application/json');
  requestHeaders.set(HttpHeader.Authorization, getAuthBearerValue(token));

  return { headers: requestHeaders.toJSON(), withCredentials: true };
};

export const isAuthorized = (): boolean => {
  return !!getWebStoreApiClient().account;
};
